import { useEffect, useState, useCallback } from 'react'
import { authHeaders } from '../utils/authFetch'

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080'

export function useRecipeAIHistory(branchId) {
    const [history, setHistory] = useState([])
    const [loading, setLoading] = useState(true)

    const fetchHistory = useCallback(async () => {
        setLoading(true)
        try {
            const params = branchId ? `?branchId=${branchId}` : ''
            const res = await fetch(`${BASE_URL}/api/recipe-ai-history${params}`, {
                headers: authHeaders(),
            })
            const data = await res.json()
            if (res.ok) setHistory(data ?? [])
        } catch (err) {
            console.error('Error fetching recipe AI history:', err)
        }
        setLoading(false)
    }, [branchId])

    useEffect(() => { fetchHistory() }, [fetchHistory])

    const saveAnalysis = async ({ summary, recommendations, scopeLabel, dateRange }) => {
        try {
            const res = await fetch(`${BASE_URL}/api/recipe-ai-history`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', ...authHeaders() },
                body: JSON.stringify({ branchId, summary, recommendations, scopeLabel, dateRange }),
            })
            const data = await res.json()
            if (!res.ok) return { data: null, error: new Error(data.error || 'Failed to save') }
            setHistory(prev => [data, ...prev])
            return { data, error: null }
        } catch (err) {
            return { data: null, error: err }
        }
    }

    const deleteAnalysis = async (id) => {
        try {
            const res = await fetch(`${BASE_URL}/api/recipe-ai-history/${id}`, {
                method: 'DELETE',
                headers: authHeaders(),
            })
            if (!res.ok) return { error: new Error('Failed to delete') }
            setHistory(prev => prev.filter(h => h.id !== id))
            return { error: null }
        } catch (err) {
            return { error: err }
        }
    }

    return { history, loading, saveAnalysis, deleteAnalysis }
}